import {Modal} from 'antd';

let isShowingModal = false; // 防重复弹窗

export function showWarningMessageBox(msg) {

    if (isShowingModal) return Promise.resolve(); // 已经有弹窗，不再重复弹
    isShowingModal = true;

    return new Promise((resolve) => {
        const modal = Modal.warning({
            title: 'Warning',
            content: (
                <div style={{ whiteSpace: 'pre-line' }}>
                    {msg}
                </div>
            ),
            // okText: 'OK',
            onOk: () => {
                modal.destroy();    // 手动关闭弹窗
                isShowingModal = false; // 复位标识
                resolve();
            },
            okButtonProps: {
                style: {
                    backgroundColor: '#d5001c',
                    borderColor: '#d5001c',
                    outline: 'none',
                    boxShadow: 'none',
                },
            },
            cancelButtonProps: { style: { display: 'none' } }, // 不显示取消按键
        });
    });
}
